// @flow
import React from 'react';
import PropTypes from 'prop-types';
import DashboardLoadingPlaceholder from './DashboardLoadingPlaceholderComponent';

type Props = {
  locale: string,
  isLoading: boolean,
};

const translations = {
  // US, CA
  'en-us': {
    headline: 'Our suite of branded merch just got bigger!',
    subText: (
      <>Explore the latest additions <a href="https://www.moo.com/us/branded-merchandise">here</a>.</>
    ),
    closing: 'See something you like? Don’t forget to ask your Account Manager about exclusive pricing offered only to MOO Business customers!',
  },
  // UK, EU, AU
  default: {
    headline: 'Ready to elevate your brand with custom merch?',
    subText: (
      <>Check out the full suite <a href="https://www.moo.com/uk/branded-merchandise">here</a>.</>
    ),
    closing: 'If you see something you like, don’t forget to ask your Account Manager about exclusive pricing offered only to MOO Business customers!',
  },
};

const Announcements = ({ isLoading, locale }: Props) => (
  <div className="u-marginTop-s u-marginTop-m@large u-padding-horizontal-m u-padding-vertical-s u-padding-vertical-m@large dashboard-page__announcements dashboard-page__item">
    <h3 className="u-marginBottom-s u-marginBottom-m@large u-paddingBottom-s u-paddingBottom-m@large u-fontSize-xl dashboard-page__item-heading">
      Announcements
    </h3>
    {isLoading ? (
      <DashboardLoadingPlaceholder type="triple" />
    ) : (
      (() => {
        const content = translations[locale] || translations.default;
        return (
          <div className="u-fontSize-m">
            <div className="u-fontSize-l u-fontFamily-primaryMedium">
              {content.headline}
              <div className="u-fontSize-m">
                {content.subText}
              </div>
            </div>
            <div>
              {content.closing}
            </div>
          </div>
        );
      })()
    )}
  </div>
);

Announcements.propTypes = {
  locale: PropTypes.string.isRequired,
};

Announcements.contextTypes = {};

export default Announcements;
